import { createSelector } from 'reselect'

export const getBoardName = (state, props) => {
  return state['view-board'].view[props.boardContext.id].name
}

export default () => createSelector(
  [
    getBoardName
  ],
  (
    boardName
  ) => ({
    boardName
  })
)
